import { Injectable, Provider } from '@angular/core';

import { Observable, of } from 'rxjs';

import { UserTheme } from '@bn/primitives';
import { THEME_PERSISTENCE, ThemePersistence } from '@bn/web-ui/theme';

/**
 * Pins Partner Portal to the light theme.
 *
 * PP has no dark design, so it must not read the account-level theme the way the dashboard
 * adapter does — a partner with dark mode on in dash.bunny.net would get a PP rendered in an
 * unsupported theme, plus a `/v2/user/settings` fetch to find out. Swap in a real adapter
 * once PP has deliberate dark-theme coverage.
 */
@Injectable({ providedIn: 'root' })
export class LightThemePersistence implements ThemePersistence {
  loadTheme$(): Observable<UserTheme> {
    return of(UserTheme.light);
  }

  saveTheme$(): Observable<unknown> {
    return of(null);
  }
}

/** Pin the app to the light theme: never read or persist the account-level choice. */
export const provideLightTheme = (): Provider => ({
  provide: THEME_PERSISTENCE,
  useExisting: LightThemePersistence,
});
